// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import Vant from 'vant';
import 'babel-polyfill'
import 'vant/lib/index.css';

import promise from 'es6-promise';
promise.polyfill();


import { Toast } from 'vant';

//require('es6-promise').polyfill();
//缓存页面
// import Navigation from 'vue-navigation'
// Vue.use(Navigation, {router})

//懒加载
import VueLazyLoad from 'vue-lazyload'
Vue.use(VueLazyLoad,{  
  error:require('../static/images/nopic.gif'),
  loading:require('../static/images/load.gif')
})

Vue.use(Toast);

import SlimCropper from 'vue-slim-cropper'
Vue.use(SlimCropper)


import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload)


import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

import VueCropper from 'vue-cropper'
Vue.use(VueCropper)

Vue.use(Vant);


// or with options
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: 'dist/error.png',
  loading: 'dist/loading.gif',
  attempt: 1
})



Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js